import { GraphQLClient } from 'graphql-request';

import { getConfig, ENV, Environment } from 'config/baseConfig';

const graphqlUrl = getConfig('GRAPHQL_URL');
const credentialsConfig = getConfig('GRAPHQL_CREDENTIALS_MODE') || 'include';

if (!graphqlUrl) {
  throw new Error('GRAPHQL_URL configuration is required');
}

const validCredentials: RequestCredentials[] = ['include', 'omit', 'same-origin'];
if (!validCredentials.includes(credentialsConfig as RequestCredentials)) {
  throw new Error(
    `Invalid GraphQL credentials mode: ${credentialsConfig}. Must be one of: ${validCredentials.join(
      ', '
    )}`
  );
}

/**
 * Ensure the graphql url is absolute.
 * We use relative url for production env because it's supported by Apollo Client. In `graphql-request`, it will be converted to absolute url.
 */
let absoluteGraphqlUrl = graphqlUrl;
if (ENV === Environment.PROD && !graphqlUrl.startsWith('http')) {
  absoluteGraphqlUrl = new URL(graphqlUrl, window.location.origin).href;
}

export const gqlClient = new GraphQLClient(absoluteGraphqlUrl, {
  credentials: credentialsConfig as RequestCredentials
});
